import React from "react";
import ProgressionChartBase from "components/VOCVOIProgressionChart/ProgressionChartBase";
import Style from "components/VOCVOIProgressionChart/ProgressionChart.module.css";
import { getVOCVOIProgressionChartTitle, getVariantsColorsMap } from "service/textRetrieval";
import Select from "react-select";
import { getData } from "service/GenericData";
import BarChartBase from "components/VOCVOIProgressionChart/BarChartBase";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
// import { WHORegionNames } from "util/constants";
/**
 * Component that renders a StackedBarChart
 */

function ProgressionChart({ textLiterals
}) {
  const [title, setTitle] = React.useState("");
  const avgValue = "p";
  const avgValues = {
    p: `Percentage`,
  };
  const [variantsColorsMap, setVariantsColorsMap] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [allCountryData, setAllCountryData] = React.useState([]);
  const [countryOptions, setCountryOptions] = React.useState([]);
  // const [groupedCountryOptions, setGroupedCountryOptions] = React.useState([])
  const [country, setCountry] = React.useState("All");
  const [selectIsLoading, setSelectIsLoading] = React.useState(true);
  const [chartIsLoading, setChartIsLoading] = React.useState(true);
  const [barChartData, setBarChartData] = React.useState([]);
  const [allCountriesCountData, setAllCountriesCountData] = React.useState([]);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      // borderBottom: '0px dotted pink',
      // color: state.isSelected ? 'red' : 'black',
      padding: 20,
      // innerHeight: 10,
      height:15,
      paddingTop: 5,
      // paddingBottom: 0
      // outerHeight:10
    }),
    groupHeading:(provided, state) => ({
      ...provided,
      // borderBottom: '0px dotted pink',
      // color: state.isSelected ? 'red' : 'black',
      // padding: 20,
      // innerHeight: 10,
      height:20,
      fontSize: 10,
      color: '#212529',
      fontWeight: 'bold'
      // paddingTop: 5
      // outerHeight:10
    }),
   
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';
  
      return { ...provided, opacity, transition };
    }
  }

  // Adding conversion from week number to date
  function parseResult(result) {
    // for (const region of result) {
    //   region.md.sort((a, b) => a.ym - b.ym);
    // }

    return result;
  }

  React.useEffect(() => {
    setTitle(getVOCVOIProgressionChartTitle(textLiterals));
    setVariantsColorsMap(getVariantsColorsMap(textLiterals));

    // getData(`vocvoi_progression_chart`).then((result) => {
      getData( `rsv_freq`).then((result) => {
      if (result != null) {
        console.debug(result)

        setAllCountryData(result.progressionChartData);
        setAllCountriesCountData(result.barChartData);

        // set countryOptions
        setCountryOptions(result.progressionChartData.map((item) => {
          if (item.country === 'All') return { "value": "All", "label": "All Countries" }
          return { "value": item.country, "label": item.country };
        }))

        // let continentsOptions=[{"label":"All Countries","options":[{"value": "All", "label": "All Countries"}]}]
        // let continentList=result.continentList
        // if(continentList&&continentList.length>0){
        //   for(let i=0;i<continentList.length;i++ ){
        //     let continent=continentList[i].continent
        //     let whoregionofficename=WHORegionNames[continent]
        //     let country_element=continentList[i].countries
        //     let countryOptions=[]
        //     for(let j=0;j<country_element.length;j++){
        //       let country=country_element[j].ctry
        //       countryOptions.push({"label":country,"value":country})
        //     }
        //     continentsOptions.push({"label":whoregionofficename,"options":countryOptions})
        //   }
        // }
        // setGroupedCountryOptions(continentsOptions)

        setSelectIsLoading(false);
        setChartIsLoading(false);
      }
      else {
        // setIsLoading(true);
      }
    });

    // getData(`variants_countries_count`).then((result) => {
    //   if (result != null) {
    //     setAllCountriesCountData(result);
    //   }
    // });
  }, [textLiterals]);

  React.useEffect(() => {
    setChartIsLoading(true);

    if (allCountryData != null && allCountryData.length > 0) {
      setData(null);
      let countryData = allCountryData.filter((item) => {
        return item.country === country;
      })[0].countryData;
      setData(parseResult(countryData));

      // setBarChartData(parseResult(countryData));

      // setChartIsLoading(false);
    }

    if (allCountriesCountData != null && allCountriesCountData.length > 0) {
      let countryCountData = allCountriesCountData.filter((item) => {
        return item.country === country;
      })[0].countryData;

      setBarChartData(countryCountData.sort((a, b) => a.ym - b.ym));

      setChartIsLoading(false);
    }

  }, [allCountryData, country, allCountriesCountData]);

  return (
    <Container className={Style.container}>
      <Row>
        <Col xs={12} lg={12} >
          <h2 className={Style.title}>
            {title ?? "VOC/VOI Progression"}
          </h2>
        </Col>
      </Row>
      <Row className="mb-1 mt-3" >
        <Col xs={12} lg={12} >
          {/* <div> */}

          {/* <div className={Style.subtitle}>
            Click Legend to show/hide areas
          </div> */}
          <div className="{Style.countrySelectContainer} d-flex justify-content-center" >
            <Select
              // styles={customStyles}
              className={Style.countrySelect}
              isDisabled={false}
              isLoading={selectIsLoading}
              isClearable={false}
              isSearchable={true}
              name="Country Name"
              placeholder="Filter by country..."
              value={countryOptions.filter((option)=>option.value === country)}
              options={countryOptions} 
              // defaultValue={[{"value": "All", "label": "All Countries"}]}
              // options={groupedCountryOptions}
              onChange={(e) => setCountry(e.value)}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={8} className="mb-4">
          <ProgressionChartBase textLiterals={textLiterals}
            avgValueKey={avgValue}
            avgValueLabel={avgValues[avgValue]}
            variantsColorsMap={variantsColorsMap}
            data={data}
            isLoading={chartIsLoading} />
        </Col>
        <Col xs={12} lg={4} className="mb-4">
          <BarChartBase textLiterals={textLiterals}
            data={barChartData}
            isLoading={chartIsLoading}
          />
        </Col>
      </Row>
      {/* </div> */}
    </Container>
  );
}

export default ProgressionChart;
